import { IntegrationApiFeaturesCongestionReportsContractsDataUnderlyingAsset as UnderlyingAsset } from '@alliander-fe/api';

/**
 * This function gets the causes from the underlying assets and returns a readable string.
 * @param underlyingAssets - The underlying assets of the congestion report.
 * @returns A readable string of the causes.
 */
export const getCauses = (underlyingAssets: UnderlyingAsset[] | undefined | null) => {
  if (!underlyingAssets) return '';
  
  const causes = underlyingAssets?.map((asset) => asset.cause);
  const uniqueCauses = [...new Set(causes)].join(', ');
  return uniqueCauses.toLowerCase();
};
